import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import {Grid} from 'react-bootstrap';
import Breadcrumbs from 'system/breadcrumbs';

import {Wrapper} from 'system/wrapper';
import {SearchFail} from 'components/common';
import Pagination from 'pagination';

import {TenderList} from './tender-list';
import Spinner from 'spinner';

import {loadTenders} from 'redux/actions/portal/prozorro';

const mapStateToProps = state => ({
  tenders: state.prozorro.get('tenderList'),
  isLoading: state.prozorro.get('isLoading')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (offset) => dispatch(loadTenders(10, offset))
});

class Procurements extends Component {

  componentWillMount() {
    const page = this.props.match.params.page || 1;
    const offset = 25 * (page - 1);
    this.props.onLoad(offset);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
      const page = nextProps.match.params.page || 1;
      const offset = 25 * (page - 1);
        this.props.onLoad(offset);
    }
  }

  render() {

    const { tenders, isLoading } = this.props;

    if (tenders === undefined) {
      return (
        <Wrapper>
          <Spinner/>
        </Wrapper>
      )
    }

    return (
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/infocenter">Інфоцентр</Link></li>
          <li><Link to="/infocenter/procurements">Державні закупівлі</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Державні закупівлі</h2>
            {tenders.get('result').size > 0 ? (
              <div>
              {isLoading ? (
                <Spinner/>
              ):(
                <TenderList tenders={tenders}/>
              )}
              </div>

             
            ):(
              <SearchFail>Державні закупівлі відсутні</SearchFail>
            )}
            <Pagination counts={this.props.tenders.get('result').get('countAllRecords')} path={`/infocenter/procurements/`} matched={this.props.match.params.page} limits={25} />

          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(Procurements));



// WEBPACK FOOTER //
// ./src/system/information-center/procurements/index.js